module.exports = __webpack_public_path__ + "img/hero-image-stores@2x.bef9c902.jpg";